export enum TAB_API_ENUMS {
  CURL = "Curl",
  JS = "Javascript",
  PYTHON = "Python",
}
